var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageContainer',[_c('v-row',{staticClass:"flex justify-center",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"pa-2 pb-3 pt-0",attrs:{"cols":"12"}},[_c('PageHeading',{attrs:{"title":"Models","show-current-round":true}}),_c('NumeraiPaper',{staticClass:"mb-3"},[_c('ModelsTable')],1)],1)],1),_c('Footer',{staticClass:"py-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }